import { Content } from '@phrasee/phrasee-typings'

import { useAppSelector } from 'common/hooks/redux'
import useGetContentQuery from 'features/unifiedFlow/api/queries/useGetContentQuery'

import { getAllComponentElements } from '../../features/unifiedFlow/contentPage/helpers'

const useSelectedComponentElement = () => {
  const selectedElementId = useAppSelector(
    (state) => state.unifiedFlow.selectedElementId
  )
  const activeContentId = useAppSelector(
    (state) => state.unifiedFlow.activeContentId
  )

  return useGetContentQuery(activeContentId, {
    select: (content: Content) => {
      const allComponentElements = getAllComponentElements(content)

      const selectedElement = allComponentElements.find(
        (element) => element.element_id === selectedElementId
      )

      return selectedElement
    },
  })
}
export default useSelectedComponentElement
